import { findProvider, providerForSourceSystem } from './providerCatalog';
import type { BatchSummary, Capabilities, ProviderInfo } from './types';

/**
 * The provider an import belongs to: the server's own provider entry when it sent one, otherwise (an older server
 * that sends no provider list) the client's name-only copy of the catalog. Never invents support: a provider that
 * is not found at all gives null.
 */
export function providerOf(
  batch: Pick<BatchSummary, 'sourceSystem' | 'sourceProvider'>,
  capabilities: Pick<Capabilities, 'providers'>,
): ProviderInfo | null {
  const byId = batch.sourceProvider ? capabilities.providers.find((p) => p.id === batch.sourceProvider) : undefined;
  return byId
    ?? capabilities.providers.find((p) => p.sourceSystem === batch.sourceSystem)
    ?? (batch.sourceProvider ? findProvider(batch.sourceProvider) : undefined)
    ?? providerForSourceSystem(batch.sourceSystem)
    ?? null;
}
